import axios from "axios";
const backend_url = process.env.VUE_APP_HOSTNAME
const domain_url = process.env.VUE_APP_DOMAIN
const ENV = process.env.NODE_ENV
const MODE = process.env.VUE_APP_MODE
const SUPPORT_BOT = (process.env.VUE_APP_AUTH_BOT) ? process.env.VUE_APP_AUTH_BOT : ''
const VERSION = (process.env.VUE_APP_VERSION) ? process.env.VUE_APP_VERSION : '1'
import BigNumber from "bignumber.js";
export default class Connect {
    constructor() {

    }

    copy_clipboard(text){
        var textArea = document.createElement("textarea");
        textArea.style.position = 'fixed';
        textArea.style.top = 0;
        textArea.style.left = 0;
        textArea.style.width = '2em';
        textArea.style.height = '2em';
        textArea.style.padding = 0;
        textArea.style.border = 'none';
        textArea.style.outline = 'none';
        textArea.style.boxShadow = 'none';
        textArea.style.background = 'transparent';
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
            var successful = document.execCommand('copy');
        } catch (err) {
            console.log('Oops, unable to copy');
        }
        document.body.removeChild(textArea);
    }

    formatDate(value){
        if(!value) return ''
        let date, year, month, day, hours, minutes, seconds;
        date = new Date(value);
        year = date.getFullYear();
        month = date.getMonth()+1;
        day = date.getDate();

        hours = date.getHours();
        minutes = date.getMinutes();
        seconds = date.getSeconds();

        if (day < 10) {
            day = '0' + day;
        }
        if (month < 10) {
            month = '0' + month;
        }

        if (hours < 10) {
            hours = '0' + hours;
        }

        if (minutes < 10) {
            minutes = '0' + minutes;
        }

        return `${day}.${month}.${year} ${hours}:${minutes}`
    }

    screen_size(that) {
        if(!that.window) return 'xl'
        if(that.window.width < 576)     return 'xs'
        if(that.window.width < 768)     return 'sm'
        if(that.window.width < 992)     return 'md'
        if(that.window.width < 1200)    return 'lg'
        if(that.window.width < 1536)    return 'xl'
        if(that.window.width >= 1536)   return '2xl'
        return '2xl'
    }

    getStatusSeverity(status) {
        switch (status) {
            case 'canceled':
            case 'reverted':
            case 'closed':
            case 'rejected':
            case 'failed':
                return 'danger';
            case 'completed':
            case 'success':
            case 'paid':
            case 'approved':
            case 'active':
                return 'success';
            case 'confirmed':
            case 'past_due':
                return 'contrast';
            case 'created':
                return 'info';
            case 'moderation':
            case 'pending':
            case 'process':
            case 'processing':
            case 'refunded':
                return 'warn';
            case 'expired':
            default:
                return 'secondary';
        }
    }
    getStatusTitle(status) {
        switch (status) {
            case 'pending':
                return 'Ожидание';
            case 'processing':
                return 'В обработке';
            case 'paid':
                return 'Оплачен';
            case 'confirmed':
            case 'completed':
                return 'Выполнен';
            case 'canceled':
                return 'Отменен';
            case 'reverted':
                return 'Возвращен';
            case 'failed':
                return 'Ошибка';
            case 'approved':
                return 'Подтвержден';
            case 'active':
                return 'Активен';
            case 'rejected':
                return 'Отклонен';
            case 'refunded':
                return 'Возвращен';
            case 'past_due':
                return 'Просрочен';
            default:
                return status;
        }
    }

    getKycStatus(status){
        if(!status) return 'Не проверен'
        switch (status) {
            case 'not_sent':
                return 'Не отправлен';
            case 'pending':
                return 'На рассмотрении';
            case 'processing':
                return 'В обработке';
            case 'approved':
                return 'Подтвержден';
            case 'rejected':
                return 'Отклонен';
            case 'completed':
                return 'Завершен';
            default:
                return status;
        }
    }

    getKycSeverity(status){
        if(!status) return 'secondary'
        switch (status) {
            case 'not_sent':
                return 'secondary';
            case 'pending':
                return 'info';
            case 'processing':
                return 'info';
            case 'approved':
                return 'success';
            case 'rejected':
                return 'danger';
            case 'completed':
                return 'success';
            default:
                return 'secondary';
        }
    }

    getBankNameByCode(code){
        const banks = {
            'avangard':     'Авангард',
            'aquaman':      'Аква Банк',
            'oleg_bank':    'Олег Банк',
            'alpaka':       'Альпака',
            'renova':       'Ренова',
            'california':   'Калифорния',
        }
        return (banks[code]) ? banks[code] : code
    }
    
    formatAmount(value, currency, digits=2){
        if(value==undefined || value==null || value==NaN) return null
        const num = new BigNumber(value).toFixed(digits)
        if(!num) return null
        if(currency==null) return num
        currency = currency.toLowerCase()
        if(num==0) return '0 ' + currency.toUpperCase()

        try{
            if(currency && (currency == 'usdt' || currency == 'usdt_trc')){
                return new Intl.NumberFormat('en-US').format(num, {minimumFractionDigits: digits}) + ' USDT'
            }
            return new Intl.NumberFormat('ru-RU', { style: 'currency', currency: currency, minimumFractionDigits: digits}).format(num)
        } catch (e) {
            return num+' '+currency
        }
    }

    formatAmountNocur(value, digits=2){
        if(!value) return null
        const num = new BigNumber(value).toFixed(digits)
        if(!num) return null
        if(num==0) return 0

        try{
            return new Intl.NumberFormat('ru-RU', { style: 'decimal', currency: undefined, minimumFractionDigits: digits}).format(num)
        } catch (e) {
            return num
        }
    }

    isUserInGroup(group, arrGroups){
        if(!group || !arrGroups) return false
        return arrGroups.includes(group)
    }

    get_short_id(id){
        if(id){
            return id.substr(18, 6)
        }else{
            return id
        }
    }

    format_amount(value, currency, digits=2){
        if(value==undefined || value==null || value==NaN) return null
        const num = new BigNumber(value).toFixed(digits)
        if(!num) return null
        if(currency==null) return num
        currency = currency.toLowerCase()
        if(num==0) return '0 ' + currency.toUpperCase()

        try{
            if(currency && (currency == 'usdt' || currency == 'usdt_trc')){
                return new Intl.NumberFormat('en-US').format(num, {minimumFractionDigits: digits}) + ' USDT'
            }
            return new Intl.NumberFormat('ru-RU', { style: 'currency', currency: currency, minimumFractionDigits: digits}).format(num)
        } catch (e) {
            return num+' '+currency
        }
    }
    
    format_date(value){
        if(!value) return ''
        let date, year, month, day, hours, minutes, seconds;
        date = new Date(value);
        year = date.getFullYear();
        month = date.getMonth()+1;
        day = date.getDate();

        hours = date.getHours();
        minutes = date.getMinutes();
        seconds = date.getSeconds();

        if (day < 10) {
            day = '0' + day;
        }
        if (month < 10) {
            month = '0' + month;
        }

        if (hours < 10) {
            hours = '0' + hours;
        }

        if (minutes < 10) {
            minutes = '0' + minutes;
        }

        return `${day}.${month}.${year} ${hours}:${minutes}`
    }

    copy_clipboard(text){
        var textArea = document.createElement("textarea");
        textArea.style.position = 'fixed';
        textArea.style.top = 0;
        textArea.style.left = 0;
        textArea.style.width = '2em';
        textArea.style.height = '2em';
        textArea.style.padding = 0;
        textArea.style.border = 'none';
        textArea.style.outline = 'none';
        textArea.style.boxShadow = 'none';
        textArea.style.background = 'transparent';
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
            var successful = document.execCommand('copy');
        } catch (err) {
            console.log('Oops, unable to copy');
        }
        document.body.removeChild(textArea);
    }

    GetClassByLabel(label){
        if(!label) return ''
        if(label == 'virtual') return 'surface-100 text-600'
        if(label == 'virtual_debit') return 'surface-600 text-100'
        if(label == 'current') return 'bg-red-100 text-red-600'
        if(label == 'deposit') return 'bg-green-100 text-green-600'
        if(label == 'service') return 'bg-blue-100 text-blue-600'
        if(label == 'vcard') return 'bg-blue-50 text-blue-500'
        if(label == 'transfer') return 'bg-green-300 text-white'
        if(label == 'merchant') return 'bg-blue-100 text-blue-600'
        if(label == 'partner') return 'surface-100 text-600'
        if(label == 'comission') return 'bg-green-50 text-green-600'
        if(label == 'liquidity') return 'bg-orange-100 text-orange-700'
        if(label == 'withdraw') return 'bg-yellow-100 text-yellow-700'
        if(label == 'topup') return 'bg-green-400 text-white'
        if(label == 'vendor') return 'bg-purple-400 text-white'
        if(label == 'freeze') return 'bg-blue-400 text-white'
        if(label == 'fund') return 'bg-red-400 text-white'
        return ''
    }

    GetWalletNameByLabel(label){
        if(!label) return null
        switch (label) {
            case 'current':
                return label
            case 'virtual':
                return 'Виртуальный'
            case 'virtual_debit':
                return 'Дебетовый'
            case 'deposit':
                return 'Пополнение'
            case 'service':
                return 'Сервисный'
            case 'vcard':
                return 'Карточный'
            case 'transfer':
                return 'Перевод'
            case 'merchant':
                return 'Торговый'
            case 'partner':
                return 'Партнерский'
            case 'comission':
                return 'Комиссия'
            case 'liquidity':
                return 'Ликвидность'
            case 'withdraw':
                return 'Вывод'
            case 'topup':
                return 'Пополнение'
            case 'vendor':
                return 'Поставщик'
            case 'freeze':
                return 'Заморозка'
            case 'fund':
                return 'Фонд'
            default:
                return label
        }
    }

    is_id(id){
        if(!id) return false
        if(id.length==24) return true
        else return false
    }

    get_short_name(name, length=15){
        if(name) {
            if(name.length > length) return name.substr(0, length-3)+'...'
            else return name
        }
        else return name
    }

    // определяем тип кошелька по id аккаунта
    GetSystemAccountName(value, account_id, walletList=[]){
        if(!value) return null
        if(!walletList || walletList.length==0) return null
        if(account_id && value == account_id) return 'current'

        const wallet = walletList.find(wallet => {
            if(wallet.accounts && wallet.accounts.length > 0 && wallet.accounts.includes(value)) return true
            return false
        })
        if(wallet) return wallet.ext_type
        return null
    }

}

